import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ContactFormModule, DetailPopupCardsModule, FilterEngineV2Component, PanelComponent, ToolbarV2Module } from '@iot-platform/iot-platform-ui';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { MasterViewEngineModule } from '@iot-platform/table-engine';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { CardsModule } from '../../components/cards/cards.module';
import { MatMenuListModule } from '../../components/mat-menu-list/mat-menu-list.module';
import { OyanInfoDisplayModule } from '../../containers';
import { LinkReceiversFormDialogComponent } from './components/link-receivers-form-dialog/link-receivers-form-dialog.component';
import { SiteCardComponent } from './components/site-card/site-card.component';
import { SiteConfigurationsComponent } from './components/site-configurations/site-configurations.component';
import { SiteContactsComponent } from './components/site-contacts/site-contacts.component';
import { SiteGatewaysComponent } from './components/site-gateways/site-gateways.component';
import { SiteInfoFormComponent } from './components/site-info-form/site-info-form.component';
import { SiteProductsComponent } from './components/site-products/site-products.component';
import { SiteStocksComponent } from './components/site-stocks/site-stocks.component';
import { SiteOverviewComponent } from './containers/site-overview/site-overview.component';
import { SitesShellComponent } from './containers/sites-shell/sites-shell.component';
import { SitesRoutingModule } from './sites-routing.module';
import { SitesEffects } from './state/effects/sites.effects';
import * as fromSites from './state/reducers';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatToolbarModule,
    MatTooltipModule,
    TranslatePipe,
    PanelComponent,
    ToolbarV2Module,
    DetailPopupCardsModule,
    MasterViewEngineModule,
    OyanInfoDisplayModule,
    CardsModule,
    MatMenuListModule,
    ContactFormModule,
    StoreModule.forFeature(fromSites.featureKey, fromSites.reducers),
    EffectsModule.forFeature([SitesEffects]),
    SitesRoutingModule,
    InfoDisplayPipe,
    SiteCardComponent,
    FilterEngineV2Component
  ],
  declarations: [
    SitesShellComponent,
    SiteOverviewComponent,
    SiteInfoFormComponent,
    SiteProductsComponent,
    SiteConfigurationsComponent,
    SiteGatewaysComponent,
    SiteStocksComponent,
    LinkReceiversFormDialogComponent,
    SiteContactsComponent
  ]
})
export class OyanUiSitesModule {}
